// @ts-nocheck
import React, { useEffect, useState } from "react";
import SoftBox from "../../../components/common/softBox";
import SoftTypography from "../../../components/common/softTypography";
import SoftInput from "../../../components/common/softInput";
import SoftButton from "../../../components/common/softButton";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { createRoleData } from "../../../features/role";
import DashboardNavbar from "../../../components/navbars/dashboardNavbar";
import { FormControl, MenuItem, Select } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { getPermissionData } from "../../../features/permission";

const AddRole = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [language, setLanguage] = useState("en");
  const { data: permissions } = useSelector(
    (state: any) => state.permissions
  );
  const { data: roles, status: roleStatus } = useSelector(
    (state: any) => state.roles
  );

  const [formData, setFormData] = useState({
    name: "",
    permissions: [],
  });

  useEffect(() => {
    // Check if permissions are already loaded
    if (!(permissions && permissions.length > 0)) {
      dispatch(getPermissionData({ language }));
    }
  }, []);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    // console.log("handleChange", name, value, type, checked);
    let { permissions } = formData;
    if (name === "permissions") {
      if (checked) {
        // If the checkbox is checked, add the permission to the array
        permissions = [...permissions, value];
      } else {
        // If the checkbox is unchecked, remove the permission from the array
        permissions = permissions.filter((perm) => perm !== value);
      }
      setFormData((prev) => ({
        ...prev,
        [name]: permissions,
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: type === "checkbox" ? checked : value,
      }));
    }
  };

  const handleSubmit = () => {
    dispatch(createRoleData({ data: formData }));
    if (roleStatus) {
      toast.success("Role created successfully");
      navigate("/roles");
    } else {
      toast.error("Failed to create role");
    }
  };

  return (
    <SoftBox className="language-box">
      <DashboardNavbar />
      <SoftBox>
        <SoftBox mb={2}>
          <SoftTypography variant="h4" fontWeight="bold" textAlign="left">
            Add Role
          </SoftTypography>
        </SoftBox>

        <SoftBox component="form" role="form" >
          <SoftBox mb={2}>
            <FormControl fullWidth size="small">
              <SoftTypography
                htmlFor="language"
                style={{
                  fontSize: "15px ",
                  fontWeight: "500",
                  lineHeight: "normal",
                  marginBottom: "10px",
                }}
              >
                Language
              </SoftTypography>
              <Select
                id="language"
                name="language"
                value={language}
                onChange={(e) => setLanguage(e.target.value)}
                IconComponent={KeyboardArrowDownIcon}
                fullWidth
                size="small"
                sx={{
                  padding: "0px 8px !important",
                  height: "40px !important",
                  display: "block !important",
                  ".MuiSelect-select": {
                    padding: "0px 8px !important",
                    height: "40px !important",
                  },
                  ".MuiSelect-nativeInput": {
                    height: "40px !important",
                  },
                  ".css-1e270hg-MuiSvgIcon-root-MuiSelect-icon": {
                    display: "block !important",
                    fontSize: "1.25rem !important",
                  },
                  ".css-8kuacp-MuiSvgIcon-root-MuiSelect-icon": {
                    display: "block !important",
                    fontSize: "1.25rem !important",
                  },
                }}
              >
                <MenuItem style={{ marginBottom: "5px" }} value="en">
                  English
                </MenuItem>
                <MenuItem value="ar">Arabic</MenuItem>
              </Select>
            </FormControl>
          </SoftBox>

          <SoftBox mb={2}>
            <SoftBox mb={1} ml={0.5}>
              <SoftTypography
                component="label"
                variant="caption"
                fontWeight="bold"
              >
                Name
              </SoftTypography>
            </SoftBox>
            <SoftInput
              type="text"
              name="name"
              placeholder="Enter the Role Name"
              value={formData.name}
              onChange={handleChange}
            />
          </SoftBox>
          {permissions && permissions.length > 0 && (
            <SoftBox mb={2}>
              <SoftTypography
                component="label"
                variant="caption"
                fontWeight="bold"
              >
                Permissions
              </SoftTypography>
              <SoftBox
                sx={{ display: "flex", alignItems: "center", flexWrap: "wrap" }}
              >
                {permissions.map((permission, index) => (
                  <SoftBox
                    mb={2}
                    key={`permission_` + index}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      padding: "5px 10px 0px 0px",
                    }}
                  >
                    <input
                      name="permissions"
                      id={permission.name}
                      type="checkbox"
                      checked={
                        formData.permissions?.includes(permission._id) || false
                      }
                      onChange={handleChange}
                      value={permission._id}
                      style={{
                        marginRight: "5px",
                        padding: "10px",
                        borderRadius: "5px",
                        border: "1px solid #ccc",
                      }}
                    />
                    <SoftTypography
                      component="label"
                      variant="caption"
                      fontWeight="bold"
                      htmlFor={permission.name}
                    >
                      {permission.name}
                    </SoftTypography>
                  </SoftBox>
                ))}
              </SoftBox>
            </SoftBox>
          )}

          {/* Submit Button */}
          <SoftBox mt={4} mb={1}>
            <SoftButton
              variant="gradient"
              color="info"
              fullWidth
              onClick={handleSubmit}
              type="submit"
            >
              Submit
            </SoftButton>
          </SoftBox>
        </SoftBox>
      </SoftBox>
    </SoftBox>
  );
};

export default AddRole;
